// Skin registry: palette (index.css) + structural LAYOUT PROFILE (here).
// Components switch on layout.{nav,hero,card,home} so structure changes per skin.
export const DEFAULT_SKIN = "classic-red";
export const SKINS = ["classic-red", "early2010s", "glassshelf", "thegrid", "videostore", "spotlightblue", "neon80s", "ancientsocial", "clickwheel"];
export const FREE_SKINS = ["classic-red", "early2010s"];
export const isFreeSkin = (id) => FREE_SKINS.includes(id);

export const SKIN_LAYOUTS = {
  "classic-red":   { nav: "cinematic", hero: "billboard", card: "poster", home: "standard", light: false },
  "early2010s":    { nav: "utility",   hero: "masthead",  card: "tile",   home: "standard", light: true },
  "glassshelf":    { nav: "float",     hero: "spotlight", card: "shelf",  home: "standard", light: false },
  "thegrid":       { nav: "guide",     hero: "none",      card: "cell",   home: "guide",    light: false },
  "videostore":    { nav: "aisle",     hero: "wall",      card: "box",    home: "standard", light: false },
  "spotlightblue": { nav: "flagship",  hero: "colossal",  card: "bigtile",home: "standard", light: false },
  "neon80s":       { nav: "scanline",  hero: "marquee",   card: "cassette",home: "standard", light: false },
  "ancientsocial": { nav: "profile",   hero: "social",    card: "profile", home: "social",   light: true },
  "clickwheel":    { nav: "wheel",     hero: "wheel",     card: "wheel",   home: "wheel",    light: true },
};
export function getLayout(skin) { return SKIN_LAYOUTS[skin] || SKIN_LAYOUTS[DEFAULT_SKIN]; }

export const SKIN_TEASERS = [
  { id: "classic-red",   label: "Classic",        era: "Mid-2010s Streaming", swatch: "linear-gradient(135deg,#e50914,#181a24 55%,#0b0c10)", available: true },
  { id: "early2010s",    label: "Early 2010s",    era: "Catalog Portal",      swatch: "linear-gradient(135deg,#4cb340,#dfe3d8 55%,#fff)",   available: true },
  { id: "glassshelf",    label: "Glass Shelf",    era: "Media-Center",        swatch: "linear-gradient(135deg,#8fd3ff,#0a0a0c 60%,#000)",   available: true },
  { id: "thegrid",       label: "The Grid",       era: "2000s Guide",         swatch: "linear-gradient(135deg,#ffd21e,#10225c 55%,#0a1a4a)",available: true },
  { id: "videostore",    label: "Video Store",    era: "Rental Night",        swatch: "linear-gradient(135deg,#e0a13a,#3a2c1d 55%,#231a12)",available: true },
  { id: "spotlightblue", label: "Spotlight Blue", era: "Flagship",            swatch: "linear-gradient(135deg,#22c1ff,#1a2352 55%,#0b1233)",available: true },
  { id: "neon80s",       label: "Neon '80s",      era: "Synthwave VHS",       swatch: "linear-gradient(135deg,#ff2fb3,#7b2ff7 60%,#160a2e)",available: true },
  { id: "ancientsocial",label: "Ancient Social", era: "Profile 2005",        swatch: "linear-gradient(135deg,#ff46b0,#27e0e0 50%,#c7cada)",available: true, releaseDate: "2026-10-04T12:00:00Z" },
  { id: "clickwheel",   label: "Click Wheel",    era: "Pocket Player",       swatch: "linear-gradient(135deg,#e11d2a,#f4efe4 45%,#d9d2c3)",available: true, releaseDate: "2026-11-03T05:00:00Z" },

];

// --- Release gating -------------------------------------------------------
// A skin with a future `releaseDate` is shown as a locked "COMING SOON" tile
// until that moment. releaseDate is an ISO/UTC string; null/absent = released.
// Oct 4, 2026 8:00 AM ET (EDT, UTC-4) === 2026-10-04T12:00:00Z.
const RELEASE_DATES = Object.fromEntries(
  SKIN_TEASERS.filter((s) => s.releaseDate).map((s) => [s.id, s.releaseDate])
);

export function getSkinReleaseDate(id) {
  return RELEASE_DATES[id] ? new Date(RELEASE_DATES[id]) : null;
}

export function isSkinReleased(id) {
  const d = getSkinReleaseDate(id);
  return !d || Date.now() >= d.getTime();
}

export function formatSkinRelease(id) {
  const d = getSkinReleaseDate(id);
  if (!d) return "";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "America/New_York" });
}

// A user may use a skin if it's released OR they are an admin (early preview).
export function canUseSkin(id, isAdmin = false) {
  return isAdmin || isSkinReleased(id);
}


// Future/unreleased skins — shown in Settings as disabled "COMING SOON" tiles.
export const COMING_SOON_SKINS = [
  { id: "soon-bbs",  label: "Dial-Up BBS",     era: "'90s Terminal",   available: false },
  { id: "soon-hdtv", label: "HD Living Room",  era: "Smart-TV Era",    available: false },
  { id: "soon-ai",   label: "AI Concierge",    era: "Near Future",     available: false },
];

export function getSkin() {
  const s = localStorage.getItem("fh_skin");
  return SKINS.includes(s) ? s : DEFAULT_SKIN;
}
export function applySkin(id = DEFAULT_SKIN) {
  const chosen = SKINS.includes(id) ? id : DEFAULT_SKIN;
  document.documentElement.setAttribute("data-skin", chosen);
  localStorage.setItem("fh_skin", chosen);
  return chosen;
}
